import AGREEMENT from '../../../api/client_agreement';
import * as helpers from '../../components/helpers/Helpers';
import router from '../../router';
import * as CONSTANTS from './../../constants/client_agreement';

const getBasePricelist = () => {
  return {};
};
const getBaseAgreement = () => {
  return {
    basic_subscription_payment: CONSTANTS.CLIENT_AGREEMENT.PAYMENT_DEADLINE_TYPE_OPTIONS.IN_ADVANCE,
    payment_deadline_day: '10',
    conclusion_date: '',
    month: '',
    year: '',
    termination_date: '',
    conclusion_location: '',
    number: {
      number: '',
    },

    //sprawdzic nazewnictwo
    payment_deadline: 2,
    employees_salaries_fee: '',
    day_of_discount: 5,
    day_of_additional_fee: 10,

    type: {},
    crm: {
      client: {},
    },
    contractsettlement: null,
    plenipotentiary: null,
    is_annex: false,
  };
};
const baseBoolOptions = [
  { id: 1, label: 'Tak' },
  { id: 0, label: 'Nie' },
];
const baseTaxDeductibleExpenses = [
  { id: 1, label: '20%' },
  { id: 2, label: '50%' },
];

const basic_subscription_payment_base = [
  {
    id: CONSTANTS.CLIENT_AGREEMENT.PAYMENT_DEADLINE_TYPE_OPTIONS.IN_ADVANCE,
    label: 'z góry za bieżący okres rozliczeniowy (w pierwszym dniu roboczym każdego miesiąca lub pierwszym dniu po zawarciu umowy)',
  },
  {
    id: CONSTANTS.CLIENT_AGREEMENT.PAYMENT_DEADLINE_TYPE_OPTIONS.IN_ARREARS,
    label: 'z dołu za bieżący okres rozliczeniowy (w ostatnim dniu roboczym każdego miesiąca)',
    shortLabel: 'z dołu za bieżący okres rozliczeniowy',
  },
];

const state = {
  agreement: getBaseAgreement(),
  pricelist: getBasePricelist(),
  config: {
    actions: {},
  },
  types: [],
  paymentDeductions: [],
  basic_subscription_payment_options: [
    ...basic_subscription_payment_base,
  ],

  employees_salaries_fee_options: [
    { id: 1, label: 'z dołu na początku następnego okresu rozliczeniowego' },
    { id: 2, label: 'z dołu w bieżącym okresie rozliczeniowym' },
  ],
  payment_deadline_options: [
    { id: CONSTANTS.CLIENT_AGREEMENT.PAYMENT_DEADLINE_OPTIONS.WITHIN.id, label: 'w terminie' },
    { id: CONSTANTS.CLIENT_AGREEMENT.PAYMENT_DEADLINE_OPTIONS.UNTIL_DAY.id, label: 'do dnia' },
  ],
  payment_deadline_month_options: [
    { id: 1, label: 'następnego miesiąca' },
    { id: 2, label: 'danego miesiąca' },
  ],
};

const getters = {
  getAgreementLabelByType(state) {
    return (id) => {
      if (state.types.length === 0) {
        return {
          prefix: '',
          color: '',
        };
      }

      let typeObj = state.types.find((el) => {
        return el.id === id;
      });

      return {
        prefix: typeObj.prefix,
        color: helpers.methods.getAgreementColorByPrefix(typeObj.prefix),
      };
    };
  },

  getAgreementNamesByType(state) {
    return (id) => {
      if (state.types.length === 0) {
        return {
          prefix: '',
          color: '',
        };
      }
      let typeObj = state.types.find((el) => {
        return el.id === id;
      });

      return {
        prefix: typeObj.prefix,
        name: helpers.methods.getAgreementNamesByPrefix(typeObj.prefix),
      };
    };
  },

  getComponentNameByAgreementTypeId() {
    return (companytype) => {
      if (!companytype || Object.entries(companytype).length === 0) {
        return 'bookkeeping_staff_contract';
      }
      switch (companytype.id) {
        case 1:
        case 2:
        case 3:
          return 'bookkeeping_staff_contract';
        default:
          return 'bookkeeping_staff_contract_simplified_accounting';
      }
    };
  },
};

const actions = {
  index({ commit, dispatch, state }, url) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.index(url).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  indexEmploymentContractAgreements({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.indexEmploymentContractAgreements().then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  showAgreement({ commit, dispatch, state }, id) {
    // commit('LOADER/setLoading', true, {root: true});
    return new Promise((resolve, reject) => {
      AGREEMENT.show(id).then(response => {
        dispatch('clearAgreement');
        commit('setAgreement', response.data);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        // commit('LOADER/setLoading', false, {root: true});
      });
    });
  },
  storeAgreement({ commit, dispatch, state }, { shouldRedirect = true } = {}) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise(async (resolve, reject) => {
      await AGREEMENT.store({
        agreement: state.agreement,
        pricelist: state.pricelist,
        actions: state.config.actions,
      }).then(({ data }) => {
        shouldRedirect && router.push({ name: 'clients-agreements' })['catch'](function () {});
        resolve(data);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  updateAgreement({ commit, dispatch, state }) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.update({
        agreement: {
          ...state.agreement,
          pricelist: {
            ...state.agreement.pricelist,
            pricethreshold: [],
          },
        },
        pricelist: state.pricelist,
        actions: state.config.actions,
      }).then(response => {
        // commit('setAgreement', response.data);
        router.push({ name: 'clients-agreements' })['catch'](function () {
        });
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  destroyAgreement({ commit, dispatch }, id) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.destroy(id).then(response => {
        // dispatch('indexAddresses');
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },

  setTerminationDate({ commit, dispatch, state }, agreement) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.setTerminationDate(agreement).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  setInsurances({ commit }, value) {
    commit('setInsurances', value);
  },
  clearAgreement({ commit }) {
    commit('clearAgreement');
  },
  setPricelist({ commit }, pricelist) {
    commit('setPricelist', pricelist);
  },
  // NUMBERS
  generateNumber({ commit, dispatch, state }, payload) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.NUMBER.generate(payload).then(response => {
        commit('setNumber', response.data.number);
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  indexTypes({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      AGREEMENT.TYPES.index().then(response => {
        commit('setTypes', response.data);
        commit('setType', response.data[0]);
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  indexAgreementTypes({ commit }) {
    return AGREEMENT.TYPES.indexAgreementTypes()
      .then(({ data }) => {
        commit('setTypes', data);
        commit('setType', data[0]);
      });
  },
  getVersions({ commit }, original) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.getVersions(original).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  setConfiguration({ commit }, payload) {
    commit('setConfiguration', payload);
  },
  isProfileValidToAddAgreement({ commit }, payload) {
    return new Promise((resolve, reject) => {
      AGREEMENT.isProfileValidToAddAgreement(payload).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      });
    });
  },
  confirmAgreement({ commit }, data) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      AGREEMENT.confirmAgreement(data).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
};

const mutations = {
  setAgreements(state, agreements) {
    state.agreements = agreements;
  },
  setAgreement(state, agreement) {
    agreement.type = state.types.find(el => {
      return el.id == agreement.type;
    });
    agreement.tax_deductible_amount = 0;
    agreement.attachment = false;
    state.agreement = agreement;
  },
  clearAgreement(state) {
    state.agreement = getBaseAgreement();
  },

  setBasicSubscriptionPayment(state, basic_subscription_payment) {
    state.agreement.basic_subscription_payment = basic_subscription_payment;
  },
  setPaymentDeadline(state, payment_deadline) {
    state.agreement.payment_deadline = payment_deadline;
  },
  setEmployeesSalariesFee(state, employees_salaries_fee) {
    state.agreement.employees_salaries_fee = employees_salaries_fee;
  },
  setDayOfDiscount(state, day_of_discount) {
    state.agreement.day_of_discount = day_of_discount;
  },
  setDayOfAdditionalFee(state, day_of_additional_fee) {
    state.agreement.day_of_additional_fee = day_of_additional_fee;
  },
  setConclusionLocation(state, conclusion_location) {
    state.agreement.conclusion_location = conclusion_location;
  },

  setStartDate(state, start_date) {
    state.agreement.start_date = start_date;
  },
  setMonth(state, month) {
    state.agreement.month = month;
  },
  setYear(state, year) {
    state.agreement.year = year;
  },
  setEndDate(state, end_date) {
    state.agreement.end_date = end_date;
  },

  setTerminationDate(state, termination_date) {
    state.agreement.termination_date = termination_date;
  },

  setType(state, type) {
    state.agreement.type = type;
  },
  setNumber(state, number) {
    state.agreement.number = number;
  },
  setConclusionDate(state, conclusion_date) {
    state.agreement.conclusion_date = conclusion_date;
  },

  setNumberNumber(state, number) {
    state.agreement.number.number = number;
  },
  setTypes(state, types) {
    state.types = types;
  },

  setClient(state, client) {
    state.agreement.crm.id = _.get(client, 'crm.id', _.get(client, 'crm'));
    state.agreement.crm.client = client;
  },

  setPaymentDeadlineDay(state, payment_deadline_day) {
    state.agreement.payment_deadline_day = payment_deadline_day;
  },
  setPaymentDeadlineMonth(state, payment_deadline_month) {
    state.agreement.payment_deadline_month = payment_deadline_month;
  },
  setCompanyRepresentative(state, company_representative) {
    state.agreement.company_representative = company_representative;
  },
  setPricelist(state, pricelist) {
    state.pricelist = _.cloneDeep(pricelist);
  },
  setConfiguration(state, configuration) {
    state.config.actions = {
      ...state.config.actions,
      ...configuration,
    };
  },
  setContractSettlement(state, settlement) {
    state.agreement.contractsettlement = !!settlement ? { ...settlement } : null;
  },
  setPlenipotentiary(state, plenipotentiary) {
    state.agreement.plenipotentiary = plenipotentiary;
  },
  setIsAnnex(state, isAnnex) {
    state.agreement.is_annex = isAnnex;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
